import React from 'react';
import classnames from 'clsx';

import { FlexColumn, FlexRow } from 'ui-components/components/flex';
import { Gap } from 'ui-components/components/flex/gap';
import { Text, TextType } from 'ui-components/components/text';

import style from './style.module.less';
import { messages } from '../modals/add-alternate-location/messages';

const IMAGE_SIZE_PX = 48;

/**
 * @param {object} props
 * @param {string} [props.productName]
 * @param {string} [props.productSku]
 * @param {string} [props.thumbnailUrl]
 * @returns {JSX.Element}
 */
export const NameAndSku = ({ productName = '', productSku = '', thumbnailUrl }) => {
  return (
    <FlexRow className={style['name-sku-container']} gap={Gap.Space12}>
      {thumbnailUrl ? (
        <img
          alt={productName || 'Product image'}
          className={style['product-thumbnail']}
          height={IMAGE_SIZE_PX}
          src={thumbnailUrl}
          width={IMAGE_SIZE_PX}
        />
      ) : null}
      <FlexRow className={classnames(style['dual-field'], style['name-sku-wrap'])}>
        <FlexColumn className={style['input-wrapper']}>
          <Text textType={TextType.Label} value={messages.addToLocationLocationNameLabel} />
          <Text className={style['name-or-sku']} textType={TextType.Label} value={productName} />
        </FlexColumn>
        <FlexColumn className={style['input-wrapper']}>
          <Text textType={TextType.Label} value={messages.addToLocationLocationSkuLabel} />
          <Text className={style['name-or-sku']} textType={TextType.Label} value={productSku} />
        </FlexColumn>
      </FlexRow>
    </FlexRow>
  );
};
